<template>
  <div>
    <div v-if="navbar_show" class="nav-space"></div>
    <div class="header">
      <img src="./images/aboutus-header-bg.png" class="header-bg" />
      <b-container fluid class="pt-5 header-container">
        <b-row>
          <b-col cols="12" lg="12" order-lg="1" class="d-flex" style="align-items: center;">
            <h2 class="header-title text-white">{{$t('about.title')}}</h2>
          </b-col>
          <b-col cols="12" lg="12" order-lg="1" class="d-flex" style="flex-wrap: wrap;align-content: end;flex-direction: column-reverse;">
            <h2 class="header-title text-white">{{$t('about.title2')}}</h2>
          </b-col>
          <!-- <b-col cols="12" lg="6" order-lg="0" class="text-center">
            <b-img fluid src="./images/aboutus-photo-1.png" class="w-80 header-img d-lg-none"></b-img>
            <b-img fluid src="./images/aboutus-photo-1-pc.png" class="w-100 header-img-pc d-none d-lg-block"></b-img>
          </b-col> -->
        </b-row>
      </b-container>
    </div>
    <div class="story pb-5">
      <div class="container">
        <h1 class="story-title subtitle">{{$t("about.story.title")}}</h1>
        <p class="story-text">{{$t("about.story.text")}}</p>
      </div>
    </div>
    <div class="values">
      <div class="container">
        <h2 class="values-title subtitle">{{$t("about.values.title")}}</h2>
        <div class="d-flex values-cards mx-auto">
          <div
            v-for="(value,index) in $t('about.values.list')"
            :key="index"
            class="values-card"
            :class="{'values-card-first': index===0}"
            ref="cards"
          >
            <h5 class="values-card-title">{{value.title}}</h5>
            <p class="values-card-des">{{value.des}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="contact">
      <div class="container">
        <h2 class="contact-title d-block text-white subtitle">{{$t("contact.title")}}</h2>
        <!-- <p class="text-danger d-lg-inline pl-lg-4">{{$t("contact.sub_title")}}</p> -->
        <b-container fluid class="mt-3 px-0">
          <b-row no-gutters>
            <b-col cols="12" lg="6" order-lg="1">
              <b-img src="./images/aboutus-photo-2.png" class="w-100 mx-auto d-block d-lg-none"></b-img>
              <b-img src="./images/aboutus-photo-2-pc.png" class="w-100 mx-auto d-none d-lg-block"></b-img>
            </b-col>
            <b-col cols="12" lg="6" order-lg="0" class="pl-0">
              <div class="mx-auto ml-lg-0 pt-3 contact-list">
                <p v-for="(value,index) in $t('contact.list')" :key="index" class="contact-item text-white">
                  {{value.title}}{{value.text}}
                </p>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openline: window.innerHeight / 2,
      navbar_show: true,
    };
  },
  mounted() {
    //给window添加一个滚动滚动监听事件
    if(this.isMobile()) window.addEventListener("scroll", this.handleScroll);
    if(this.$route.query.hide){
      this.$emit('navbar', false);
      this.$emit('footer', false);
      this.navbar_show = false;
    }
  },
  destroyed() {
    //离开该页面需要移除这个监听的事件
    if(this.isMobile()) window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      //改变元素#searchBar的top值
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      for (let card of this.$refs.cards) {
        var rect = card.getBoundingClientRect();
        if (rect.top < (this.openline + 5) && rect.bottom > (this.openline - 5)) {
          card.classList.toggle("values-card-active", true);
        }
        else{
          card.classList.toggle("values-card-active", false);
        }
      }
    },
    isMobile() {
      let flag = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)
      return flag;
    }
  }
};
</script>
<style lang="scss" scoped>
.nav-space {
  height: 40px;
  background: black;
}
.container{
  max-width: 100rem;
  margin: auto;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}

.header {
  position: relative;
  background: #cccccc;
  overflow: hidden;
  width: 100%;
  &-bg {
    position: absolute;
    bottom: 30%;
    max-width: 200%;
  }
  &-title {
    white-space: pre-wrap;
  }
}
.story {
  padding: 2.5rem 0;
  position: relative;
  background-image: url("./images/aboutus-story-bg-m.png");
  background-size: cover;
  background-position: bottom;
  overflow: hidden;
  width: 100%;

  &-title {
    font-size: 1.875rem;
    // text-align: center;
  }
  &-text {
    position: relative;
    white-space: pre-wrap;
    z-index: 101;
  }
}
.values {
  padding: 2.5rem 0;
  background-color: #1b2838;
  background: url("./images/aboutus-values-bg.png");
  background-size: cover;
  background-position: center;
  color: white;
  &-title{
    margin-bottom: 2rem;
  }
  &-cards {
    flex-direction: column;
    height: 30rem;
    width: 100%;
  }
  &-card {
    flex: auto;
    flex-direction: column;
    height: 0;
    transition: flex-grow 0.8s;
    // height: 5rem;
    // width: 0;
    border-image-source: linear-gradient(
      to left,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.8),
      rgba(255, 255, 255, 0)
    );
    border-image-slice: 1;
    border-bottom: 1px solid white;
    overflow: hidden;
    display: flex;
    justify-content: center;
    &-first {
      border-top: 1px solid white;
    }
    &-title {
      display: block;
      margin: 2rem auto;
      max-height: 100%;
    }
    &-des {
      display: block;
      max-height: 0;
      opacity: 0;
      white-space: pre;
      text-align: center;
      margin: 0;
    }
    &-active {
      flex-grow: 2;
      .values-card-title {
        display: block;
        max-height: 0;
        margin:0;
        opacity: 0;
      }
      .values-card-des {
        max-height: 100%;
        display: block;
        margin: auto;
        opacity: 1;
        transition: opacity 1.8s linear;
      }
    }
  }
}
.contact{
  padding: 2.5rem 0;
  background-color: #1b2838;
  &-list{
    font-size: 0.7rem;
  }
  &-item{
    margin-bottom: 0.3rem;
  }
}
@include media-breakpoint-up(lg) {
  .subtitle{
    font-size: 2.2rem !important;
    text-align: left;
    padding-left: 0;
    margin: 2rem 0;
  }
  .nav-space {
    height: 60px;
  }
  .container{
    padding: 0 2.5rem;
  }
  .header{
    padding: 5rem 0 5rem ;
    &-bg {
      top: 0;
      height: 100%;
      width: 100%;
    }
    &-container{
      width: 70%;
    }
    &-title{
      font-size: 4rem !important;
    }
  }
  .story{
    background-image: url("./images/aboutus-story-bg.png");
    padding: 5rem 0;
    &-text{
      width: 100%;
      max-width: 953px;
      font-size: 1.375rem ;
      line-height: 1.64;
      margin: auto;
    }
  }

  .values {
    padding: 5rem 0;
    background-color: #1b2838;
    text-align: center;
    padding-bottom: 0;

    &-cards {
      flex-direction: row;
      height: 30rem;
    }
    &-card {
      flex: auto;
      transition: flex-grow 0.8s;
      height: 100%;
      width: 0;
      border-image-source: linear-gradient(
        to top,
        rgba(255, 255, 255, 0.8),
        rgba(255, 255, 255, 0)
      );
      border-image-slice: 1;
      border-right: 1px solid white;
      border-bottom: 0;
      overflow: hidden;
      display: flex;
      justify-content: center;
      &-first {
        border-left: 1px solid white;
      }
      &-title {
        display: block;
        margin: auto;
      }
      &-des {
        // display: none;
        display: block;
        max-width: 0;
        max-height: 0;
        opacity: 0;
        white-space: pre;
      }
      &:hover {
        flex-grow: 2;
        .values-card-title {
          display: none;
        }
        .values-card-des {
          max-width: 100%;
          max-height: 100%;
          display: block;
          margin: auto;
          opacity: 1;
          transition: opacity 1.8s linear;
        }
      }
    }
  }

  .contact{
    padding: 2rem 0 5rem;

    &-list{
      font-size: 1.5rem;
    }
    &-item{
      margin-bottom: 1rem;
    }
  }
}
</style>
